import { CLEAR_GROUP_LIST, DELETE_GROUP_LIST, INIT_GROUP_LIST, SET_ASSIGN_GROUP_ID, SET_GROUP_COMPONENT_TYPE, SET_GROUP_FOCUS, SET_GROUP_LIST, SET_GROUP_PANEL, SET_GROUP_STATUS, SET_LAST_GROUP_UPDATE_TIME } from "./actionType";

export function setGroupStatus(status) {
    return {
        type: SET_GROUP_STATUS,
        status
    }
}

export function setGroupPanel(panel) {
    return {
        type: SET_GROUP_PANEL,
        panel
    }
}

export function setGroupFocus(uuid) {
    return {
        type: SET_GROUP_FOCUS,
        uuid
    }
}

export function setGroupComponentType(componentType) {
    return {
        type: SET_GROUP_COMPONENT_TYPE,
        componentType
    }
}


export function setGroupList(list) {
    return {
        type: SET_GROUP_LIST,
        list
    }
}

export function deleteGroupList(uuid) {
        
    return {
        type: DELETE_GROUP_LIST,
        uuid
    }
}

export function setAssignGroupId(id) {
    return {
        type: SET_ASSIGN_GROUP_ID,
        id
    }
}

export function setGroupUpdate(time) {
    return {
        type: SET_LAST_GROUP_UPDATE_TIME,
        time
    }    
}

export function clearGroupList() {
    return {
        type: CLEAR_GROUP_LIST
    }
}

export function initGroupList(list) {
    return {
        type: INIT_GROUP_LIST,
        list
    }
}